/**
 * Legal Deploy targets (rule.md §6): a reserve stack is placed onto one of the
 * player's own empty home cells.
 */
import { type CellId, HOME_CELLS } from "../data/board";
import type { PlayerId } from "../types/common";
import type { AugmentedWarState } from "../types/game-state";

export function legalDeployCells(
  state: AugmentedWarState,
  player: PlayerId,
): readonly CellId[] {
  return HOME_CELLS[player].filter((home) => !state.board[home]);
}
